<template>
  <div>
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu :title="$t('account-settings.favorites.title')" />
    </div>
    <div class="favorites-wrapper">
      <el-tabs
        v-if="user.id"
        v-model="activeName"
      >
        <el-tab-pane name="first">
          <span
            v-if="locale === 'en'"
            slot="label"
          >{{ $t('account-settings.favorites.items') }} ({{ itemsBadge }})</span>
          <span
            v-else
            slot="label"
          >({{ itemsBadge }}) {{ $t('account-settings.favorites.items') }}</span>
          <entity-list
            ref="adsList"
            res="ads"
            :filter="adsFilters || []"
            :sort="sort || []"
            :res-options="adsResourceOptions"
            :post-on-index="false"
            @response="itemsBadge = $event.total"
          >
            <template
              slot="item"
              slot-scope="slotProps"
            >
              <ads-row
                :param-item="slotProps.item"
                :user="true"
                @reloadList="reloadAdsList"
              />
            </template>
          </entity-list>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span
            v-if="locale === 'en'"
            slot="label"
          >{{ $t('account-settings.favorites.sellers') }} ({{ sellersBadge }})</span>
          <span
            v-else
            slot="label"
          >({{ sellersBadge }}) {{ $t('account-settings.favorites.sellers') }}</span>
          <entity-list
            ref="usersList"
            res="users"
            :filter="userFilters || []"
            :sort="sort || []"
            :res-options="userResourceOptions"
            @response="sellersBadge = $event.total"
          >
            <template
              slot="item"
              slot-scope="slotProps"
            >
              <seller
                :item="slotProps.item"
                @reloadList="reloadUsersList"
              />
            </template>
          </entity-list>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-col v-if="isMobile">
      <footer-menu />
    </el-col>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import EntityList from '@/components/Core/EntityList';
  import AdsRow from '@/components/Ads/AdsRow';
  import Seller from '@/components/Seller';
  import MobileBackMenu from '@/components/Mobile/MobileBackMenu';
  import FooterMenu from '@/components/Mobile/FooterMenu';

  export default {
    name: 'Favorites',
    components: {
      FooterMenu,
      MobileBackMenu,
      AdsRow,
      Seller,
      EntityList,
    },
    data() {
      return {
        itemsBadge: 0,
        sellersBadge: 0,
        activeName: 'first',
        sort: [['created_at', 'desc']],
        adsResourceOptions: {
          file: true,
          currency: true,
          favoring_logged_in_user: true,
          contact_info: true,
          'category:parent': true,
        },
        userResourceOptions: {
          file: true,
          favoring_logged_in_user: true,
        },
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        user: state => state.auth.user,
        locale: state => state.locale,
      }),
      adsFilters() {
        return [{
          property: 'active',
          operator: '=',
          value: 1,
        }, {
          property: 'favoring_users.id',
          operator: '=',
          value: this.user.id,
        }];
      },
      userFilters() {
        return [{
          property: 'favoring_users.id',
          operator: '=',
          value: this.user.id,
        }];
      },
    },
    methods: {
      reloadUsersList() {
        if (this.$refs.usersList) {
          this.$refs.usersList.doRefresh();
        }
      },
      reloadAdsList() {
        if (this.$refs.adsList) {
          this.$refs.adsList.doRefresh();
        }
      },
    },
  };

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AccountSettings/Favorites.vue